import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { Loading } from "@/layouts/loading";
import { SearchParams } from "@/routes/(pharma)/_layout/reports/sales-summary/-data/model";
import { DailySalesResponse } from "@/gen/sales/daily_sales_pb";
import { pharmacyClient } from "@/connect";

const API_URL = import.meta.env.VITE_API_URL as string;

export const Route = createFileRoute("/(pharma)/_layout/reports/sales-summary/")({
  component: Component,
  validateSearch: SearchParams,
  loaderDeps: ({ search: { date } }) => ({
    date,
  }),
  loader: async (params): Promise<DailySalesResponse> => {
    const { date } = params.deps;
    try {
      const salesReport = await pharmacyClient.dailySales({
        date: date,
      });
      return salesReport;
    } catch (error) {
      throw new Error("Failed to fetch sales summary");
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});
